module.exports = __webpack_public_path__ + "img/avatar-02-120x120.55032482.png";